import { createSlice } from "@reduxjs/toolkit";

const brandSlice = createSlice({
    name: 'brand',
    initialState: {
        brandConfigs: {}
    },
    reducers: {
        setBrandConfig(state, action) {
            state.brandConfigs = action.payload;
        }
    },
});

export const brandActions = brandSlice.actions;
export default brandSlice;